import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import BaseMonthPicker from 'modules/core/components/MonthPicker'

type MonthPickerProps = React.ComponentProps<typeof BaseMonthPicker> & {
  field: Field
}

const MonthPicker = ({
  readonly,
  field,
  label,
  value,
  readonlyValue,
  mandatory,
  secondaryLabel,
  placeholder,
}: MonthPickerProps) => {
  const error = field && !field.isDirty ? field.errors && field.errors[0] : null

  function onChange(date: string) {
    if (!field) return

    field.set(date)
  }

  return (
    <BaseMonthPicker
      readonly={readonly}
      label={label}
      readonlyValue={readonlyValue}
      mandatory={mandatory}
      secondaryLabel={secondaryLabel}
      placeholder={placeholder}
      onChange={onChange}
      value={value || field.value || ''}
      error={error || undefined}
    />
  )
}

export default observer(MonthPicker)
